import React from 'react';
import PropTypes from 'prop-types';
import { ElementPaginator, LinkPaginator } from './style';

const ItemPaginator = ({ className, selected, onClick, children }) => (
  <ElementPaginator className={className}>
    <LinkPaginator
      href="#"
      selected={selected}
      onClick={event => {
        event.preventDefault();
        onClick();
      }}
    >
      {children}
    </LinkPaginator>
  </ElementPaginator>
);

ItemPaginator.propTypes = {
  className: PropTypes.string,
  selected: PropTypes.bool,
  onClick: PropTypes.func,
  children: PropTypes.node
};

ItemPaginator.defaultProps = {
  selected: false,
  onClick: undefined,
  children: '0'
};

export default ItemPaginator;
